<template>
    <div class="gosuhu single-header">
        <secondary-header title="Check In" backRoute="default"></secondary-header>

        <main>
            <div class="container">
                <div class="text-center py-5">
                    validating...
                </div>
            </div>

            <loader v-if="true"></loader>
        </main>
    </div>
</template>

<script>
export default {
    props: ['token'],

    methods: {
        getMerchantBranch() {
            fireLoader()
            axios.post(this.GLOBAL.API_BASE_URL +"branch-visit/get-branch", {branch_ref_no: this.qr_code_data})
                .then(response => {
                    if(response.data) {
                        this.$router.push({name: 'customer-detail', params: {branch: response.data, scan_type: 'in'}})
                        Swal.close()
                    } else {
                        Swal.fire({
                            // type: 'error',
                            text: 'Merchant/Branch not found. Please try again',
                            timer: 5000
                        })
                    }
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
        },
    },

    created() {
        if(this.$route.query.token) {
            localStorage.token = this.$route.query.token
        }
        if (this.$route.query.qr_code_data) {
            sessionStorage.qr_code_data = this.$route.query.qr_code_data;
        }
        axios.post(this.GLOBAL.API_BASE_URL + "customer-details", {
                token: localStorage.token
            })
            .then(response => {
                if(response.data.status == 'OK') {
                    axios.defaults.headers.common['Authorization'] = 'Bearer '+ localStorage.token;
                    if(sessionStorage.qr_code_data) {
                        this.qr_code_data = sessionStorage.qr_code_data;
                        this.getMerchantBranch()
                        sessionStorage.qr_code_data = ''
                    } else {
                        // window.location.replace("/history");
                        this.$router.push({name: 'history'})
                    }
                } else {
                    Swal.fire({
                        text: 'Session expired',
                        timer: 5000,
                        onClose: () => {
                            // window.location.href = this.GLOBAL.MAIN_GONET_URL
                            window.location.replace(this.GLOBAL.MAIN_GONET_URL);
                        }
                    })
                }
            })
            .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
            .finally(() => this.$set(this.state, 'loading', false))
    }
}
</script>